import React from 'react'
import './ExploreProperties.css'

const ExploreProperties = () => {
    return (
        <div className='ep-main-container'>
            <div className="ep-container">
                <section className="ep-container-left">
                    <div className="ep-container-left-header">
                    <h2>Smart selection of premium real estate</h2>
                    <p>Stay connected with Gladious. Our team will help you find your dream home in right place and at right time.</p>
                </div>
                <div className="ep-container-left-footer">
                    <button className='ep-left-properties-btn'><a href="/properties">Explore Properties</a></button>
                    <button className='ep-left-contact-btn'><a href="/contact">Get Consultation</a></button>
                </div>
                </section>
                <section className="ep-container-right">
                    <div className="ep-container-right-front-image">
                    <img className='front-image' src="https://res.cloudinary.com/dggey8rb6/image/upload/v1776936467/image1_kvjin5.jpg" alt="" />
                    </div>
                    <div className="ep-container-right-back-image">
                    <img className='back-image' src="https://res.cloudinary.com/dggey8rb6/image/upload/v1776936461/pexels-rdne-8292770_giepzy.jpg" alt="Explore Properties" loading = "lazy" />
                                        </div>

                </section>
            </div>
        </div>
    )
}

export default ExploreProperties